"use client";

import FeatureApplicationList from "./FeatureApplicationList";

export default function AdminApplicationList() {
  return (
    <FeatureApplicationList
      titleKey="titles.company_applications"
      descriptionKey="descriptions.company_applications"
    />
  );
}
